const cdnDomain = 'https://d2bccpbzpdjeaa.cloudfront.net';

export const getCdnListingSrc = (
  src: string,
  options: Record<string, unknown> = {},
) => {
  const srcClean = src.replace('https://s3-us-west-1.amazonaws.com/', '');
  const bucket = srcClean.split('/')[0];
  const key = srcClean.split('/')[1];

  if (!key || !bucket) {
    return src;
  }

  const optimizedSrcOptions = {
    bucket,
    key,
    ...options,
  };

  if (typeof window !== 'undefined') {
    return `${cdnDomain}/${btoa(JSON.stringify(optimizedSrcOptions))}`;
  } else {
    return `${cdnDomain}/${Buffer.from(JSON.stringify(optimizedSrcOptions)).toString('base64')}`;
  }
};
